import script from "./RegisterGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterGroup.vue?vue&type=script&setup=true&lang=js"

import "./RegisterGroup.vue?vue&type=style&index=0&id=7020ec48&lang=scss"

const __exports__ = script;

export default __exports__